import Container from 'typedi';
import PlanificationRepository from '../repositories/PlanificationRepository';

class PlanificationService {
  planificationRepository;
  constructor() {
    this.planificationRepository = Container.get(PlanificationRepository);
  }
  getPlanificationsDashboard = async () => await this.planificationRepository.getPlanificationsDashboard();
  getPlanifications = async (page, rowsPerPage, filters) => await this.planificationRepository.getPlanifications(page, rowsPerPage, filters);
}
Container.set({ id: PlanificationService, type: PlanificationService });

export default PlanificationService;
